import React from 'react';
import type { Hotspot } from '@types';
import Checkbox from '@components/Checkbox';
import getFeatName from './getFeatName';

interface Props {
  data: Hotspot;
  isSelected: boolean;
  onClick: (params: { id: string }) => void;
}

function BatchModeItem({ data, isSelected, onClick }: Props) {
  return (
    <div
      className="mb-10 flex h-35 cursor-pointer items-center rounded bg-black-#34 px-10"
      onClick={() => onClick({ id: data.id })}
    >
      <Checkbox
        className="flex-shrink-0"
        checked={isSelected}
        onClick={() => onClick({ id: data.id })}
      />
      <div className="mx-5 truncate">{data.title}</div>
      <div className="ml-auto flex-shrink-0 text-sm text-black-gray">
        {getFeatName(data.data.code)}
      </div>
    </div>
  );
}

export default React.memo(BatchModeItem);
